(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geotiff-bathymetry", [], factory);
	else if(typeof exports === 'object')
		exports["geotiff-bathymetry"] = factory();
	else
		root["geotiff-bathymetry"] = factory();
})(self, function() {
return 